const comments = [
  {
    name: '吃瓜一线群众',
    time: '2小时前',
    text: '91黑料网真的是我每天必刷的网站，更新速度太快了，很多独家爆料别的地方根本看不到。视频播放也很流畅，强烈推荐！',
    likes: '2.3k',
  },
  {
    name: '娱乐观察家',
    time: '5小时前',
    text: '作为关注娱乐圈十几年的老粉，91黑料网的爆料可信度确实比其他平台高很多，每条都有据可查，建议继续保持这种风格。',
    likes: '1.8k',
  },
  {
    name: '匿名用户',
    time: '8小时前',
    text: '前段时间那个网红塌房的系列视频就是在这里先看到的，之后才被其他平台转发。这个网站的信息源真的很快，已经安利给身边的朋友了。',
    likes: '1.5k',
  },
  {
    name: '社会观察员',
    time: '12小时前',
    text: '不仅娱乐圈的爆料全面，社会热点的深扒也很到位。那个食品安全调查的视频看了让人触目惊心，希望平台能多做这类内容。',
    likes: '986',
  },
  {
    name: '深夜吃瓜人',
    time: '1天前',
    text: '移动端体验做得不错，晚上躺床上刷黑料视频很方便。内容分类也很清晰，想看哪个领域的直接选就行，不用翻来翻去。',
    likes: '752',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-900 mb-3">读者热评</h2>
          <p className="text-foreground-500 text-sm max-w-xl mx-auto">看看91黑料网的读者们都怎么说</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
          {comments.map((item, i) => (
            <div
              key={i}
              className={`bg-background-50 rounded-xl p-5 border border-background-200/60 ${
                i === 0 ? 'lg:col-span-2' : ''
              }`}
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-xs font-bold text-primary-600">{item.name.charAt(0)}</span>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-800">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{item.text}</p>
              <div className="flex items-center gap-1 text-foreground-400">
                <i className="ri-heart-line text-xs" />
                <span className="text-xs">{item.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}